import {
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import * as React from 'react';
import ReactPlayer from 'react-player/lazy';

import styles from './PhotoScroller.scss';

const PhotosScroller = ({
    photos,
    currentPhotoIndex,
    isVideoScroller,
}) => {
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(currentPhotoIndex);
    const maxSteps = photos.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
    };

    return (
        <Box
            sx={{
                flexGrow: 1,
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                }}
            >
                {isVideoScroller ? (
                    <div className={styles.modalVideo}>
                        <ReactPlayer
                            className={styles.reactPlayer}
                            width="100%"
                            height="100%"
                            url={photos[activeStep].url}
                            light
                            controls
                        />
                    </div>
                ) : (
                    <img
                        className={styles.modalImage}
                        src={photos[activeStep].url}
                        alt={`User graphic ${activeStep + 1}`}
                    />
                )}
            </Box>
            <MobileStepper
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                nextButton={(
                    <Button size="small" onClick={handleNext}>
                        Next &nbsp;
                        {theme.direction === 'rtl' ? (
                            <FontAwesomeIcon icon={faChevronLeft} border />
                        ) : (
                            <FontAwesomeIcon icon={faChevronRight} />
                        )}
                    </Button>
                )}
                backButton={(
                    <Button size="small" onClick={handleBack}>
                        {theme.direction === 'rtl' ? (
                            <FontAwesomeIcon icon={faChevronRight} />
                        ) : (
                            <FontAwesomeIcon icon={faChevronLeft} border />
                        )}
                        &nbsp; Back
                    </Button>
                )}
            />
        </Box>

    );
};

PhotosScroller.propTypes = {
    photos: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string.isRequired,
        label: PropTypes.string,
    })).isRequired,
    currentPhotoIndex: PropTypes.number,
    isVideoScroller: PropTypes.bool,
};

PhotosScroller.defaultProps = {
    currentPhotoIndex: 0,
    isVideoScroller: false,
};

export default PhotosScroller;
